module.exports = __webpack_public_path__ + "static/media/cred_mod_C.ab9fbc76.gif";